var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3977_23916)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3977_23916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8096 15.8748L9.03127 17.5294C7.60175 18.3808 5.76733 17.8735 4.94193 16.3992C4.11677 14.925 4.60815 13.0324 6.03767 12.181L8.81604 10.5264C9.27079 10.2556 9.42659 9.65583 9.16404 9.18676C8.90149 8.71768 8.32002 8.55697 7.86527 8.82779L5.0869 10.4824C2.74908 11.8747 1.94535 14.9687 3.29516 17.3799C4.64466 19.7913 7.64422 20.6203 9.98204 19.2281L12.7604 17.5735C13.2152 17.3026 13.371 16.7029 13.1084 16.2338C12.8459 15.7647 12.2644 15.604 11.8096 15.8748Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2061 6.7121C19.8565 4.30097 16.8567 3.47186 14.5194 4.86399L11.7411 6.51861C11.2863 6.78943 11.1305 7.38921 11.3931 7.85828C11.6556 8.32736 12.2371 8.48807 12.6918 8.21725L15.4702 6.56263C16.8994 5.71148 18.7341 6.21883 19.5593 7.69282C20.3845 9.16705 19.8931 11.0596 18.4636 11.9107L15.6853 13.5653C15.2305 13.8361 15.0747 14.4359 15.3373 14.905C15.5998 15.3741 16.1813 15.5348 16.636 15.264L19.4144 13.6094C21.7518 12.2175 22.5556 9.12324 21.2061 6.7121Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82281 15.2786C7.08537 15.7476 7.66683 15.9083 8.12159 15.6375L17.3307 10.1536C17.7855 9.88277 17.9413 9.28299 17.6787 8.81391C17.4162 8.34484 16.8347 8.18413 16.3799 8.45495L7.17082 13.9389C6.71607 14.2097 6.56026 14.8095 6.82281 15.2786Z",
    fill: "#666666"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3977_23916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.2672,
    height: 24,
    fill: "white",
    transform: "translate(0.572266)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3977_23916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5247,
    height: 18.0017,
    fill: "white",
    transform: "matrix(0.963862 0.266401 -0.251423 0.967877 6.06836 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.b32a9cfb70747ad746998e280e75b582.svg";
export { ForwardRef as ReactComponent };